import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import Pagination from "react-js-pagination";
import moment from "moment";
import Header from "./../../Header";
import "../../assets/css/alie.css";
import Train from "./train";
import ReactModal from "react-modal";

import CheckPicker from "rsuite/CheckPicker";
import "rsuite/CheckPicker/styles/index.css";
import SelectPicker from "rsuite/SelectPicker";
import "rsuite/SelectPicker/styles/index.css";

//import AssessmentList from "./CircularProgress";

import AssessmentList from "./AssessmentList";

import InteractionsModal from "../chat/components/InteractionsModal";

import { FiMoreVertical } from "react-icons/fi";
import {
  FaSyncAlt,
  FaTrashAlt,
  FaBan,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";

const AlieResponseEval = () => {
  const [messages, setMessages] = useState([]);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const debounceTimeout = useRef(null);

  const [showInteractionsModal, setShowInteractionsModal] = useState(false);
  const [selectedInteractionsId, setSelectedInteractionsId] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 20;
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const [selectedAgents, setSelectedAgents] = useState([]);
  const [selectedDocTypes, setSelectedDocTypes] = useState([]);

  const [agents, setAgents] = useState([]);

  const [filter, setFilter] = useState(null);

  const statusOptions = [
    { label: "Draft", value: 0 },
    { label: "Trained", value: 1 },
    { label: "Pending", value: 2 },
    { label: "Failed", value: 3 },
    { label: "Blocked", value: 5 },
  ];

  const storedPermission = localStorage.getItem("user_permission");

  const parsedPermission = storedPermission
    ? storedPermission.split(",")
    : null;

  // if (!parsedPermission) {
  //   window.location.href = "/404"; // Redirect to login if no permissions found
  //   return;
  // } else if (!parsedPermission.includes("16")) {
  //   //Check permission does not incluses
  //   window.location.href = "/404"; // Redirect to login if no permissions found
  //   return;
  // }

  const fetchAgents = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_CRM}/ai/agents`);
      const result = await response.json();
      setAgents(result.data || []);
    } catch (err) {
      console.error("Failed to fetch agents", err);
    }
  };

  const fetchMessages = async (page) => {
    setLoading(true);
    try {
      // Replace with your actual API endpoint
      const payload = {
        filter: {
          flag: filter || "all",
        },
      };

      const response = await fetch(
        `${process.env.REACT_APP_CRM}/ai/message/evals?page=${page}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
      setMessages(data.data);
      setTotal(data.total);
    } catch (error) {
      console.error("Error fetching messages:", error);
    } finally {
      setLoading(false);
    }
  };

  const getFlagBadges = (flags) => {
    if (!flags || flags.length === 0)
      return <span className="text-muted">No flags</span>;

    const flagColors = {
      "search-failure": "danger",
      "low-confidence": "warning",
      downvoted: "danger",
      "under-review": "info",
    };

    return flags.map((flag, idx) => (
      <span
        key={idx}
        className={`badge badge-${flagColors[flag] || "default"} bg-${
          flagColors[flag] || "default"
        } mr-1`}
        style={{ margin: 5 }}
      >
        {flag}
      </span>
    ));
  };

  const BuildSourceLink = (evalSource, conversation_id, interaction_id) => {
    if (evalSource && evalSource.customer_tattle_uuid) {
      return `/chat/${evalSource.customer_tattle_uuid}#${interaction_id}`;
    } else {
      return `/alie?conversation_id=${conversation_id}#${interaction_id}`;
    }
  };

  useEffect(() => {
    fetchAgents(); // load agents at mount
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
      setCurrentPage(1); // reset to page 1 on new search
    }, 400);

    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  useEffect(() => {
    fetchMessages(currentPage);
  }, [currentPage, debouncedSearch, filter]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1); // Reset to first page when searching
  };

  return (
    <div>
      <Header brecum_name="AI" brecum_page="Eval" />
      <div
        className="right_col"
        style={{ height: "100vh", overflow: "hidden" }}
      >
        <div
          className="ticket_list"
          style={{
            position: "relative",
            marginTop: "65px",
            height: "100%",
            paddingBottom: "80px",
          }}
        >
          <div
            className="customer-wrap"
            style={{
              overflowY: "auto",
              overflowX: "hidden",
              height: "100%",
              marginTop: 0,
            }}
          >
            <div class="page-top">
              <div className="containerfull">
                <div className="row align-items-center">
                  <div class="col-md-12">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex align-items-center">
                        <h2>AI Eval</h2>
                        <span class="badge-blue">{total}</span>
                      </div>
                      <div>
                        <div className="ml-10 doc-dropdown">
                          <SelectPicker
                            data={[
                              { label: "All", value: "all" },
                              {
                                label: "Search Failure",
                                value: "search_failure",
                              },
                              { label: "Downvoted", value: "downvoted" },
                              { label: "Under Review", value: "under_review" },
                              { label: "Bad Rating", value: "bad_rating" },
                            ]}
                            value={filter}
                            onChange={(value) => {
                              setFilter(value);
                              setCurrentPage(1);
                            }}
                            placeholder="Tags"
                            style={{ width: 200 }}
                            cleanable
                            searchable={false}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div class="row mt-10">
                                    <div class="col-md-8">
                                        <div class="d-flex">
                                            <div className="ml-10 doc-dropdown">
                                                <CheckPicker
                                                    data={statusOptions}
                                                    value={filter}
                                                    onChange={(values) => {
                                                        setFilter(values || []);
                                                        setCurrentPage(1);
                                                    }}
                                                    placeholder="Status"
                                                    style={{ width: 200 }}
                                                    cleanable
                                                    searchable={false}
                                                />
                                            </div>

                                            <div className="ml-10 doc-dropdown">
                                                <CheckPicker
                                                    data={agents.map((agent) => ({
                                                        label: agent.agent_name,
                                                        value: agent.agent_id,
                                                    }))}
                                                    value={selectedAgents}
                                                    onChange={(values) => {
                                                        setSelectedAgents(values || []);
                                                        setCurrentPage(1);
                                                    }}
                                                    placeholder="Agent"
                                                    style={{ width: 224 }}
                                                    searchable={false}
                                                />
                                            </div>

                                            <div className="ml-10 doc-dropdown">
                                                <CheckPicker
                                                    data={[
                                                        { label: "URL", value: "url" },
                                                        { label: "Google Doc", value: "google_doc" },
                                                    ]}
                                                    value={selectedDocTypes}
                                                    onChange={(values) => {
                                                        setSelectedDocTypes(values || []);
                                                        setCurrentPage(1);
                                                    }}
                                                    placeholder="Document Type"
                                                    style={{ width: 224 }}
                                                    searchable={false}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="searchTicket emp_dept">
                                            <input
                                                type="text"
                                                className="form-control input-f"
                                                placeholder="Search by title"
                                                autocomplete="off"
                                                value={search}
                                                onChange={handleSearchChange}
                                            />
                                            <button type="submit">
                                                <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.25 14.75C11.5637 14.75 14.25 12.0637 14.25 8.75C14.25 5.43629 11.5637 2.75 8.25 2.75C4.93629 2.75 2.25 5.43629 2.25 8.75C2.25 12.0637 4.93629 14.75 8.25 14.75Z" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                                    <path d="M15.75 16.25L12.4875 12.9875" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                                </svg>
                                            </button>
                                        </div>

                                    </div>

                                </div> */}

                {loading ? (
                  <div className="text-center" style={{ padding: "40px" }}>
                    <p>Loading...</p>
                  </div>
                ) : (
                  <div className="employee-list table-wrap mt-10">
                    <table>
                      <thead>
                        <tr>
                          <th style={{ width: "20%" }}>Date</th>
                          <th style={{ width: "15%" }}>Query</th>
                          <th style={{ width: "20%" }}>Response</th>
                          <th style={{ width: "10%" }}>Tags</th>
                          <th style={{ width: "30%" }}>Assessment</th>
                          <th style={{ width: "5%" }}>Source</th>
                        </tr>
                      </thead>
                      <tbody>
                        {messages.map((message) => (
                          <tr key={message.interaction_id}>
                            <td>
                                {moment(message.time).format('YYYY-MM-DD hh:mm A')}
                            </td>
                            <td>
                              <style>
                                {`
                                                    .important-link {
                                                    color: #007bff !important;
                                                    text-decoration: underline !important;
                                                    }
                                                    .important-link:hover {
                                                    color: #0056b3 !important; /* darker on hover */
                                                    }
                                                `}
                              </style>
                              <a
                                href={BuildSourceLink(
                                  message.eval_source,
                                  message.conversation_id,
                                  message.interaction_id
                                )}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="important-link"
                              >
                                {message.user_query.length > 50
                                  ? message.user_query.slice(0, 50) + "..."
                                  : message.user_query}
                              </a>
                            </td>
                            <td>
                              {message.response_preview.length > 50
                                ? message.response_preview.slice(0, 50) + "..."
                                : message.response_preview}
                            </td>
                            <td>{getFlagBadges(message.flags)}</td>
                            <td>
                              <AssessmentList
                                searchEvaluation={message.search_evaluation}
                                documents={message.documents}
                              />
                            </td>
                            {/* <td>{renderSources(message.documents)}</td> */}
                            {/* <td>{moment(message.created_date).format('YYYY-MM-DD hh:mm A')}</td> */}

                            <td>
                              {message.interaction_id ? (
                                <div
                                  className="interactions-button"
                                  onClick={() => {
                                    setSelectedInteractionsId(
                                      message.interaction_id
                                    );
                                    setShowInteractionsModal(true);
                                  }}
                                  style={{ cursor: "pointer" }}
                                  title="View Interactions"
                                >
                                  View Source
                                </div>
                              ) : null}
                            </td>
                          </tr>
                        ))}
                        {messages.length === 0 && (
                          <tr>
                            <td
                              colSpan="6"
                              className="text-center"
                              style={{ padding: "30px" }}
                            >
                              No Messages found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    {total > perPage && (
                      <div className="d-flex mu-pagination justify-content-between align-items-center">
                        <div className="mu-pagination__info">
                          <p className="mu-pagination__info-text">
                            Showing{" "}
                            {Math.min((currentPage - 1) * perPage + 1, total)}{" "}
                            to {Math.min(currentPage * perPage, total)} of{" "}
                            {total} entries
                          </p>
                        </div>
                        <div className="mu-pagination">
                          <Pagination
                            activePage={currentPage}
                            itemsCountPerPage={perPage}
                            totalItemsCount={total}
                            pageRangeDisplayed={5}
                            itemClass="page-item"
                            linkClass="page-link"
                            onChange={setCurrentPage}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <InteractionsModal
            interactionId={selectedInteractionsId}
            showModal={showInteractionsModal}
            setShowModal={setShowInteractionsModal}
          />
        </div>
      </div>
    </div>
  );
};

export default AlieResponseEval;



// WEBPACK FOOTER //
// ./src/components/ai/AlieResponseEval.js